import React, { ChangeEvent, createElement, useEffect, useState } from 'react';
import { Formik, Form } from 'formik';
// import { useTranslation } from 'react-i18next';
import { StyledMarkdown } from '../../styled/markdown';
import {
  FormPublicDesignFragment,
  FormPublicFieldFragment,
} from '../../../graphql/fragment/form.public.fragment';
import { useRouter } from '../../use.router';
import { getComponentByType } from '@/components/types';
import { Grid, Typography } from '@mui/material';
import { BottomNavigation } from '@/components/bottomNavigation';
import styled from 'styled-components';
import parse from 'html-react-parser';

interface Props {
  focus: boolean;
  field: FormPublicFieldFragment;
  design: FormPublicDesignFragment;

  save: (data: any) => void;
  next: (values?: any) => void;
  prev: () => void;

  slideIndex: number;
  lastSlideIndex: number;
  // this has to be passed into the component from swiper since we only reset the question's form
  // if the user wants to make another submission in the end page
  //    if we reset form here, it will lose the user's input upon them moving onto the next question
  // formik will automatically reset the form upon seeing it's intialValues change
  // in this case, a flag that tells the form to reset
  submissionCount?: number;
  //added
  totalQuestions: number;
}

/**
 * @param input email input
 * @returns if the input is an email
 */
export const isEmail = (input: string): boolean => {
  let emailRE =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  return emailRE.test(input);
};

const isLink = (input: string): boolean => {
  // https://stackoverflow.com/questions/8667070/javascript-regular-expression-to-validate-url
  let linkRE =
    /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/;
  return linkRE.test(input);
};

export const Field: React.FC<Props> = ({
  field,
  design,
  save,
  next,
  prev,
  slideIndex,
  submissionCount,
  lastSlideIndex,
  //added prop for toal question num
  totalQuestions,
}) => {
  // const router = useRouter();
  // const { t } = useTranslation();

  const FieldInput = getComponentByType(field.type);
  // const Component = createElement(FieldInput);

  // const finish = (data: any) => {
  //   console.log('received field data', data);
  //   save(data);
  //   // next();
  // };

  // const error = async () => {
  //   await message.error('Check inputs!');
  // };

  // const getUrlDefault = (): string | undefined => {
  //   if (router.query[field.id]) {
  //     return router.query[field.id] as string;
  //   }

  //   if (router.query[field.slug!]) {
  //     return router.query[field.slug!] as string;
  //   }

  //   return undefined;
  // };

  const validate = (values: any) => {
    const errors: any = {};
    if (field.required) {
      /** email */
      if (field.type === 'email' && !isEmail(values[field.id])) {
        errors[field.id] = 'Please enter a valid email';
      } else if (
        /** number */
        field.type === 'number' &&
        typeof values[field.id] !== 'number'
      ) {
        errors[field.id] = 'Please enter a number';
      } else if (field.type === 'textarea' || field.type === 'textfield') {
        /** text area and text field*/
        // trim to make sure user cannot get through with a whitespace - effectively sending an empty answer
        if (!values[field.id]) {
          errors[field.id] = 'Please enter a value';
        } else {
          if (values[field.id].trim() === '') {
            errors[field.id] = 'Please enter a non-empty value';
          }
        }
      } else if (field.type === 'link' && !isLink(values[field.id])) {
        /** link */
        errors[field.id] = 'Please enter a valid link';
      } else {
        /** default */
        if (!values[field.id]) {
          errors[field.id] = 'Please enter a value';
        }
      }
    }
    return errors;
  };

  const handleSubmit = (values: any) => {
    // if statement solely for mlb-experience
    if (field.id !== 'G7RnB7') {
      save(values);
    }
  };

  return (
    <Formik
      initialValues={{
        [field.id]: JSON.parse(field.defaultValue),
        submissionCount: submissionCount,
      }}
      onSubmit={handleSubmit}
      validate={validate}
      enableReinitialize={true}
    >
      {({ values, handleChange, errors }) => (
        <Form className='form-slide'>
          <Typography
            sx={{ typography: { sm: 'h6', xs: 'h6' } }}
            style={{ color: design.colors.question }}
          >
            {/* User can see which number question on in the form "Question X of Y" to know how far along in the survey */}
            Question {slideIndex + 1} of {totalQuestions} <br></br>
            <Typography
              sx={{ typography: { sm: 'h4', xs: 'h5' } }}
              style={{ color: design.colors.question }}
            >
              {parse(field.title)}{' '}
            </Typography>
          </Typography>
          {field.description ? (
            <StyledMarkdown
              className='question-description'
              design={design}
              type={'question'}
            >
              {field.description}
            </StyledMarkdown>
          ) : (
            <>
              <br></br>
              <br></br>
            </>
          )}

          {FieldInput && (
            <FieldInput
              design={design}
              field={field}
              onChange={handleChange}
              value={values[field.id]}
              error={errors[field.id]}
              helperText={errors[field.id]}
              submissionCount={submissionCount}
            />
          )}
          <Grid
            container
            display='flex'
            maxWidth='xl'
            sx={{ position: 'sticky', bottom: '0px' }}
          >
            <BottomNavigation
              errors={errors}
              design={design}
              field={field}
              next={next}
              prev={prev}
              slideIndex={slideIndex}
              values={values}
              lastSlideIndex={lastSlideIndex}
            />
          </Grid>
        </Form>
      )}
    </Formik>
  );
};
